const SPACE_SIZES = {
    S0: 0,
    S2: 2,
    S4: 4,
    S8: 8,
    S12: 12,
    S16: 16,
    S20: 20,
    S24: 24,
    S28: 28,
    S32: 32,
    S36: 36,
    S40: 40,
};

export { SPACE_SIZES };
//# sourceMappingURL=spaces.js.map
